
import { useLocation, useNavigate } from "react-router-dom";
import "./SingleUserDetails.css";

const SingleUserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = location.state || {};
  


//   const [userData, setUserData] = useState(() => ({
//     name: user?.name || "",
//     email: user?.email || "",
//     phoneNumber: user?.phoneNumber || "",
//     district: user?.district || "",
//     city: user?.closedCity || "",
//     age: user?.age || "",
//   }));

  if (!user) {
    return (
      <div className="user-profile-error">
        <p>No user data found.</p>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const calculateAge = (dob) => {
    if (!dob) return "Unknown";
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate());

    if (!hasHadBirthdayThisYear) {
      age -= 1;
    }

    return age;
  };

  return (
    <div className="user-profile-page">
      <h2>User Profile</h2>
      <div className="user-profile-container">
        <div className="profile-card">
          <div
            className="profile-avatar"
            style={{
              backgroundColor: getAvatarColor(user.name),
              fontSize: "72px",
              color: "white",
            }}
          >
            {user.name?.charAt(0) || "U"}
          </div>
          <h3>{user.name || "Unknown User"}</h3>
          <p>{user.email || "No email"}</p>
          <p>{user.phoneNumber || "No phone number"}</p>
          <div className="registration">
            <span>User ID</span>
            <span className="reg-number">{String(user.id).slice(0, 8)}</span>
          </div>
        </div>

        <div className="right-side-cards">
          <div className="account-info">
            <h3>Account Information</h3>
            <div className="info-grid">
              <p>
                <strong>District</strong>{" "}
                <span className="info-value">{user.district || "Unknown"}</span>
              </p>
              <p>
                <strong>City</strong>{" "}
                <span className="info-value">
                  {user.closedCity || "Unknown"}
                </span>
              </p>
              <p>
                <strong>Age</strong>{" "}
                <span className="info-value">
                  {user.age || calculateAge(user.dob) || "Unknown"}
                </span>
              </p>
              <p>
                <strong>Registration Date</strong>{" "}
                <span className="info-value">
                  {user.createdAt
                    ? new Date(user.createdAt).toLocaleDateString()
                    : "Unknown"}
                </span>
              </p>
              {/* Add more fields as if needed */}
            </div>
          </div>

          <div className="additional-info">
            {/* <h3>
              Additional Information <FaEdit className="edit-icon" />
            </h3> */}
            <div className="info-content">
              <p>
                <strong>Address:</strong> {user.address || "Not provided"}
              </p>
              <p>
                <strong>Status:</strong> {user.status || "Unknown"}
              </p>
              {/* Add more fields as if needed */}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <button className="btn btn-primary" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    </div>
  );
};

const getAvatarColor = (name) => {
  if (!name || typeof name !== "string" || name.length === 0) {
    return "#C5A3FF";
  }
  const colors = ["#C5A3FF", "#A3FFC5", "#FFC5A3", "#A3C5FF", "#90EE90"];
  const initial = name.charCodeAt(0);
  return colors[initial % colors.length];
};

export default SingleUserDetails;
